<p class="pt-3 mt-4 mb-3"></p>

<div class="row py-5" id="dark-bg">
  <div class="container p-4">
    <div class="row mt-5">
      <div class="col-12 p-2">
        <h2 class="text-center pb-3">Take Advantage</h2>
        <p class="card-text">
          Take advantage of technologies that are busy shaping how we live our
          lives and will drastically change our future. Machine learning,
          artificial intelligence, cryptocurrencies, the internet of things, the
          fourth industrial revolution are all on the rise and gaining momentum.
          This brings various forms of opportunities to the informed and early
          adopters.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="row justify-content-center text-center py-5" id="light-bg">
  <div class="container p-4">
    <h3 class="pb-4">In the News</h3>
    <div class="row px-5">
      <div class="col-md-3 pb-2">
        <div class="py-2">
          <img
            src="../../assets/img/renaissance-capital-logo_trprnt.png"
            alt=""
            class="img-circle"
            height="100"
            width="100"
          />
        </div>
        <a
          href="https://www.bloomberg.com/news/articles/2017-04-25/renaissance-mints-another-billionaire-with-two-more-on-the-cusp"
          target="_blank"
          rel="noopener noreferrer"
        >
          #Bloomberg: Renaissance Technologies</a
        >
      </div>
      <div class="col-md-3 pb-2">
        <div class="py-2">
          <img
            src="../../assets/img/wired-logo.svg"
            alt=""
            class="img-circle"
            height="100"
            width="100"
          />
        </div>
        <a
          href="https://www.wired.com/2016/01/the-rise-of-the-artificially-intelligent-hedge-fund/"
          target="_blank"
          rel="noopener noreferrer"
        >
          The Rise of the Artificially Intelligent Hedge Fund</a
        >
      </div>
      <div class="col-md-3 pb-2">
        <div class="py-2">
          <img
            src="../../assets/img/sentient_logo_trprnt.png"
            alt=""
            class="img-circle"
            height="100"
            width="100"
          />
        </div>
        <a
          href="https://www.bloomberg.com/news/articles/2017-02-06/silicon-valley-hedge-fund-takes-on-wall-street-with-ai-trader"
          target="_blank"
          rel="noopener noreferrer"
        >
          #Bloomberg: Sentient Technologies</a
        >
      </div>
      <div class="col-md-3 pb-2">
        <div class="py-2">
          <img
            src="../../assets/img/business-insider_logo.jpg"
            alt=""
            class="img-circle"
            height="100"
            width="100"
          />
        </div>
        <a
          href="http://www.businessinsider.com/bitcoin-price-surge-leads-to-growth-in-hedge-funds-2017-8"
        >
          #Business Insider: Companies trading cryptocurrencies</a
        >
      </div>
      <!-- <div class=" col-md-3">
        <a href="https://www.techemergence.com/from-past-to-future-tracing-the-evolutionary-path-of-fintech/">
        AI in fintech</a></div> -->
    </div>
  </div>
</div>

<div class="row py-5" id="dark-bg">
  <div class="container p-4">
    <div class="row">
      <div class="col-12">
        <h2 class="text-center pb-3">The Cryptocurrency Revolution</h2>
      </div>
    </div>
    <div class="row vert-align py-3">
      <div class="col-md-9 p-2">
        <p class="textContainer">
          Cryptocurrencies are starting to make an impact on global economics
          with the total global market cap approaching $ 200 billion. Not all
          are used as currency, most alt coins represent a token of a
          blockchain-based startup. Many alt coins can be used as a store of
          value because of growing demand and limited supply.
        </p>
      </div>
      <div class="col-md-3">
        <img
          class="image-section"
          src="../../assets/img/coin_use.png"
          alt="Multiple ways to earn using bitconnect"
          width="100%"
        />
      </div>
    </div>
    <div class="row vert-align py-3">
      <div class="col-md-3">
        <img
          class="image-section"
          src="../../assets/img/coin_use.png"
          alt="Multiple ways to earn using bitconnect"
          width="100%"
        />
      </div>
      <div class="col-md-9">
        <p>
          This website aims to spread cryptocurrency adoption and to kick off
          your research into emerging opportunities. One such opportunity is Bit
          Connect.
        </p>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-md-12">
        <p>
          Bit Connect started from a community of early bitcoin users in Asia
          that wanted to trade and share ideas. The community grew and lead to
          the creation of a new coin at the end of 2016 (<a
            href="https://bitcointalk.org/index.php?topic=1681719.0"
            target="_blank"
            rel="noopener noreferrer"
            >Bit Connect ICO announcement</a
          >). Like all alt coins, value is derived from perceived value and
          widespread adoption for trade. Based on the existing community of
          users, adoption grew quickly, rising past over 500 new alt coins to
          the top 15 alt coins in the world (<a
            href="https://coinmarketcap.com/"
            target="_blank"
            rel="noopener noreferrer"
            >coin market cap</a
          >) with a market cap of close to $ 1 billion.
        </p>
      </div>
    </div>
  </div>
</div>

<!-- <div class="container text-left">
  
  <div class="row">
    <div class="col-12 py-2">
      <div class="col-12 p-2">
        <div class="card px-0">
          <div class="card-block bg-faded">
            <h4 class="card-title">What does this service offer?</h4>
            <p class="card-text">The era we currently live in is one of cryptocurrencies, big data and machine learning. 
              These are forces that are busy changing the way we interact with the world around us. From 
              digital voice assistants (Alexa, Siri, Google Assistant, Cortana, etc) to financial 
              robo-advisors (<a href="https://www.bloomberg.com/news/articles/2017-07-10/secret-millions-for-0x00a651d43b6e209f5ada45a35f92efc0de3a5184">see this Bloomberg article</a>).
            </p>
          </div>
        </div>
      </div>
      
      <div class="col-12 p-2">
        <div class="card px-0">
          <div class="card-block bg-faded">
            <h3 class="text-center">This Platform</h3>
            <p class="card-text">Since their launch in November 2016, the BitConnect coin has surged up to the top 20 cryptocurrencies 
              with a market cap of close to a billion dollars (<a href="https://coinmarketcap.com/">see Coin Market Cap</a>, 
              <a href="https://coin.dance/stats">see Coin Dance</a>). Astute cryptocurrency followers will 
              remember that in the build-up to the bitcoin cash launch near the start of August 2017, it 
              was referred to as BCC. After the launch the ticker of bitcoin cash was changed to BCH - the 
              official existence of BitConnect was the reason for this.
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 p-2">
        <div class="card px-0 text-center">
          <div class="card-block bg-faded">
            <h3 class="card-title">What is it?</h3>
            <p class="card-text">BitConnect is an open source, crypto community platform designed to 
              provide multiple opportunities to earn. Here, we'll show a few of the main methods.
            </p>

            <div class="row pb-4 px-3">
              <div class="col-md-4">
                <img src="../../assets/img/coin_use.png" alt="Multiple ways to earn using bitconnect" width="100%">
              </div>
              <div class="col-md-8 px-2 pt-3">
                <h5 class="card-title"><strong>Methods 1 & 2: Mining/Minting</strong></h5>
                <p class="card-text">BitConnect Coin uses special algorithms called the POW/POS to secure 
                  the BitConnect Coin network. The moment you acquire BitConnect Coin it becomes an interest 
                  bearing asset with, currently, 50% return per 6 months through PoS minting. All you have to do to earn 
                  with this method is to hold coins in your BitConnect-QT wallet. In addition to PoS minting, 
                  BitConnect Coin can be mined with a CPU/GPU and does not need an ASIC miner like Bitcoin does.
                </p>
                <div class="row justify-content-center">
                  <button class="btn btn-outline-primary mx-4 mb-3">What is Proof of Work (POW)?</button>
                  <button class="btn btn-outline-primary mx-4 mb-3">What is Proof of Stake (POS)?</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <h4>BCC Coin Specifications:</h4>
            <p><strong>Maximum coin supply:</strong> 28 million</p>
            <p><strong>Current available supply:</strong> 6 million</p>
            <p><strong>Fresh New supply:</strong> Adding 23 million more via BCC mining (2.6 million) and BCC minting 
              (20.4 million) over the time and its purely dependent on public demand.</p>
          </div>
        </div>
      </div>
      <br>
      <h4>What is the Bitconnect lending vehicle?</h4>
      <p>BitConnect offers many ways to earn, but lending is easiest to start with and offers the highest return. 
        Their lending platform allows you to hold BCC while also lending it to their trading bot. 
        This uses a combination of proof of stake mining and algorithmic trading to deliver profits 
        that add to your account daily. You can invest BitConnect coin via the Bitconnect lending platform. 
        This investment option involves profiting from the BitConnect trading bot and volatility software. 
        You will receive daily profit based on your investment option. Upon investment term completion, 
        you will receive your <strong>CAPITAL BACK</strong> to take out from the Bitconnect lending platform or 
        optionally reinvest back in lending platform to continue receiving daily profit</p>
      
    </div>
  </div>
</div> -->

<div class="row justify-content-center text-center py-5" id="light-bg">
  <div class="container p-4">
    <div class="row justify-content-center text-center">
      <div class="col-12">
        <h2 class="pb-4">How to profit</h2>
      </div>
    </div>
    <div class="row pb-4 px-3 vert-align">
      <div class="col-md-4">
        <img
          class="image-section"
          src="../../assets/img/coin_use.png"
          alt="Multiple ways to earn using bitconnect"
          width="100%"
        />
      </div>
      <div class="col-md-8 px-2 pt-3">
        <h5 class="pt-2"><strong>Methods 1 & 2: Mining/Minting</strong></h5>
        <p class="">
          BitConnect Coin uses special algorithms called the POW/POS to secure
          the BitConnect Coin network. The moment you acquire BitConnect Coin it
          becomes an interest bearing asset with, currently, 50% return per 6
          months through PoS minting. All you have to do to earn with this
          method is to hold coins in your BitConnect-QT wallet. In addition to
          PoS minting, BitConnect Coin can be mined with a CPU/GPU and does not
          need an ASIC miner like Bitcoin does.
        </p>
        <div class="row justify-content-center">
          <a
            href="https://en.wikipedia.org/wiki/Proof_of_work"
            class="btn btn-outline-primary mx-4 mb-3"
            target="_blank"
            rel="noopener noreferrer"
          >
            What is Proof of Work (POW)?
          </a>
          <a
            href="https://en.wikipedia.org/wiki/Proof_of_stake"
            class="btn btn-outline-primary mx-4 mb-3"
            target="_blank"
            rel="noopener noreferrer"
          >
            What is Proof of Stake (POS)?
          </a>
        </div>
      </div>
    </div>

    <div class="row pb-4 px-3 vert-align">
      <div class="col-md-6 px-2 pt-3">
        <h5 class="pt-2"><strong>Method 3: Lending</strong></h5>
        <p class="">
          This method is unique to bitconnect and uses a combination of POS
          minting and a trading bot operating on the BTC/USD and other
          currencies data. Bitconnect coins are borrowed to the trading bot. It
          keeps these coins in its wallet it uses to trade. Profits are
          distributed proportionally to those who borrowed. Losses are limited
          by Method 2 (POS) from the funds held in the trading bot's wallet.
        </p>
      </div>
      <div class="col-md-6">
        <img
          src="../../assets/img/lending.png"
          alt="Multiple ways to earn using bitconnect"
          width="100%"
        />
      </div>
    </div>
  </div>
</div>

<!-- the video -->
<div class="row py-5" id="dark-bg">
  <div class="container p-4">
    <div class="row">
      <div class="col-12 p-2">
        <video
          src="../../assets/vid/What is BitConnect.mp4"
          class="col-md"
          controls
        ></video>
      </div>
    </div>
  </div>
</div>

<!-- buttons -->
<div class="container my-5">
  <div class="row justify-content-between px-2">
    <button class="btn btn-success mb-3">Learn more about BitConnect</button>
    <button [routerLink]="['/investing']" class="btn btn-success mb-3">
      Two rules for investing...
    </button>
  </div>
</div>
<hr class="pt-3" />
